import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const Footer = () => {
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-foreground text-background">
      {/* Final CTA Section */}
      <div className="border-b border-background/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
          <h2 className="font-display text-4xl lg:text-6xl font-bold text-background leading-tight mb-6 text-balance">
            Listo para transformar tu negocio?
          </h2>
          <p className="text-background/60 text-lg max-w-xl mx-auto mb-10 leading-relaxed">
            Agenda una consulta gratuita y descubre el potencial de la IA para tu empresa.
          </p>
          <Button
            onClick={scrollToContact}
            className="bg-accent text-accent-foreground hover:bg-accent/90 rounded-full px-10 py-6 text-base font-medium transition-all duration-300 group"
          >
            Comenzar Ahora
            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-300" />
          </Button>
        </div>
      </div>

      {/* Footer content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Company */}
          <div className="md:col-span-2">
            <span className="font-display text-2xl font-bold text-background block mb-4">
              Neurolytics
            </span>
            <p className="text-background/50 leading-relaxed max-w-sm">
              Transformamos empresas a traves de soluciones tecnologicas innovadoras, 
              especializandonos en inteligencia artificial y analisis de datos.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-medium text-background/40 uppercase tracking-[0.15em] mb-6">
              Servicios
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#servicios" className="text-background/70 hover:text-accent transition-colors duration-300 text-sm">
                  Inteligencia Artificial
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-background/70 hover:text-accent transition-colors duration-300 text-sm">
                  Analisis de Datos
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-background/70 hover:text-accent transition-colors duration-300 text-sm">
                  Automatizacion
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-background/70 hover:text-accent transition-colors duration-300 text-sm">
                  Software a Medida
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-medium text-background/40 uppercase tracking-[0.15em] mb-6">
              Contacto
            </h4>
            <ul className="space-y-3">
              <li className="text-background/70 text-sm">hola@neurolytics.cl</li>
              <li className="text-background/70 text-sm">+56 9 6294 2789</li>
              <li className="text-background/70 text-sm">Los Lagos, Chile</li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-background/10 mt-16 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-background/30 text-sm">
              &copy; 2025 Neurolytics. Todos los derechos reservados.
            </p>
            <div className="flex gap-8 text-sm">
              <a href="/politica-privacidad" className="text-background/30 hover:text-accent transition-colors duration-300">
                Politica de Privacidad
              </a>
              <a href="/terminos-servicio" className="text-background/30 hover:text-accent transition-colors duration-300">
                Terminos de Servicio
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
